module.exports = __webpack_public_path__ + "static/img/bg-kiko.b8edc00b.webp";